import { render, staticRenderFns } from "./roleAction.vue?vue&type=template&id=52c43fd9&scoped=true&"
import script from "./roleAction.vue?vue&type=script&lang=js&"
export * from "./roleAction.vue?vue&type=script&lang=js&"
import style0 from "./roleAction.vue?vue&type=style&index=0&id=52c43fd9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c43fd9",
  null
  
)

export default component.exports